import React from 'react'
import { Location } from '@reach/router'

export const withLocation = WrappedComponent => ({ ...props }) => (
  <Location>
    {({ location }) => <WrappedComponent {...props} location={location} />}
  </Location>
)
